import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
export type EquipmentControls = { confirmation: boolean; pickup: boolean; logistics: boolean };
export function useEquipmentControls() {
  const [controls,setControls]=useState<EquipmentControls>({confirmation:false,pickup:false,logistics:false});
  useEffect(()=>{
    let active=true;
    const load=()=>{supabase.rpc('equipment_runtime_controls').then(({data,error})=>{
      if(active) setControls(error?{confirmation:false,pickup:false,logistics:false}:{confirmation:data?.confirmation===true,pickup:data?.pickup===true,logistics:data?.logistics===true});
    });};
    load(); const timer=setInterval(load,15000);
    return()=>{active=false;clearInterval(timer);};
  },[]);
  return controls;
}
